export interface FilterItem {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  group?: string; // Optional group identifier - used for admin panel grouping
}

export interface FilterCategory {
  id: string;
  name: string;
  description?: string;
  items: FilterItem[];
  groupBy?: 'auto' | 'prefix' | 'none'; // How to group items in admin panel
  groupPrefixLength?: number; // For prefix grouping in admin panel
}

// Initial mock data for filter categories
export const mockFilterCategories: FilterCategory[] = [
  {
    id: 'department',
    name: 'Department',
    description: 'Company departments',
    items: [
      { id: 'dep-1', name: 'Engineering', active: true },
      { id: 'dep-2', name: 'Design', active: true },
      { id: 'dep-3', name: 'Product Management', active: true },
      { id: 'dep-4', name: 'Marketing', active: true },
      { id: 'dep-5', name: 'Sales', active: false }
    ]
  },
  {
    id: 'location',
    name: 'Office Location',
    description: 'Office locations',
    items: [
      { id: 'loc-1', name: 'Katowice', active: true },
      { id: 'loc-2', name: 'Gdansk', active: true }
    ]
  },
  {
    id: 'level',
    name: 'Level',
    description: 'Competence levels',
    groupBy: 'prefix',
    groupPrefixLength: 1,
    items: [
      { id: 'lvl-1a', name: '1A', active: true, group: '1' },
      { id: 'lvl-1b', name: '1B', active: true, group: '1' },
      { id: 'lvl-2a', name: '2A', active: true, group: '2' },
      { id: 'lvl-2b', name: '2B', active: true, group: '2' },
      { id: 'lvl-3a', name: '3A', active: true, group: '3' },
      { id: 'lvl-3b', name: '3B', active: true, group: '3' },
      { id: 'lvl-4a', name: '4A', active: true, group: '4' },
      { id: 'lvl-4b', name: '4B', active: true, group: '4' },
      { id: 'lvl-5a', name: '5A', active: true, group: '5' },
      { id: 'lvl-5b', name: '5B', active: true, group: '5' },
      { id: 'lvl-6a', name: '6A', active: true, group: '6' },
      { id: 'lvl-6b', name: '6B', active: true, group: '6' }
    ]
  },
  {
    id: 'specialization',
    name: 'Specialization',
    description: 'Technical specializations',
    groupBy: 'auto',
    items: [
      { id: 'spec-1', name: 'Frontend', active: true, group: 'Development' },
      { id: 'spec-2', name: 'Backend', active: true, group: 'Development' },
      { id: 'spec-3', name: 'Full Stack', active: true, group: 'Development' },
      { id: 'spec-4', name: 'DevOps', active: true, group: 'Operations' },
      { id: 'spec-5', name: 'Mobile', active: true, group: 'Development' },
      { id: 'spec-6', name: 'AI/ML', active: false, group: 'Data Science' },
      { id: 'spec-7', name: 'Data Engineer', active: true, group: 'Data Science' },
      { id: 'spec-8', name: 'UX Designer', active: true, group: 'Design' },
      { id: 'spec-9', name: 'UI Designer', active: true, group: 'Design' }
    ]
  }
]; 